import React from 'react';
import {StorageKey} from "../../../enums/StorageKey";
import {t} from "@lingui/macro";
import BukkuTooltip from "../../Tooltip";
import {EyeInvisibleOutlined} from "@ant-design/icons";
import AmountTd from "../../Table/Common/AmountTd";
import dayjs from 'dayjs';
import BankAccountListMenu from "../../ListMenu/BankAccount";
import AccountConnectStatusTag from '../../../containers/AppPage/Bank/Accounts/BankFeeds/components/AccountConnectStatusTag';

function getColumns(props) {
    const { bankFeeds } = props;
    return [
        {
            title: t`Code`,
            dataIndex: 'code',
            key: 'code',
            width: 120,
            ellipsis: true,
            align: 'left',
            render: text => (
                <div className="ellipsis-div">
                    <BukkuTooltip>
                        {text}
                    </BukkuTooltip>
                </div>),

        },
        {
            title: t`Account`,
            dataIndex: 'name',
            key: 'name',
            width: 250,
            ellipsis: true,
            align: 'left',
            render: (text, record) => (
                <div>
                    <div className="ellipsis-div">
                        <BukkuTooltip>
                            {text}
                                &nbsp;
                        </BukkuTooltip>
                        &nbsp;
                        {record.is_archived ? <EyeInvisibleOutlined /> : null}
                    </div>
                    {/*<div className="caption">
                                XXX-XXX
                            </div>*/}
                </div>),
        },
        {
            title: t`Type`,
            dataIndex: 'system_type',
            key: 'system_type',
            ellipsis: true,
            width: 100,
            align: 'left',
            render: text => {
                let type = null;
                switch (text) {
                    case 'credit_card':
                        type = t`Credit Card`;
                        break;
                    case 'bank_cash':
                        type = t`Bank`;
                        break;
                    default:
                        break;
                }

                return (
                    <div className="ellipsis-div">
                        <BukkuTooltip>{type}</BukkuTooltip>
                    </div>
                );
            },
        },
        {
            title: t`Bank Feeds`,
            dataIndex: 'bankFeedStatus',
            key: 'bankFeedStatus',
            // ellipsis: true,
            width: 120,
            align: 'left',
            render: (text, record) => {
                if (record?.bank_feed_id) {
                    const bankFeed = bankFeeds.find(feed => feed.id === record.bank_feed_id);
                    const {
                        status: bankFeedStatus,
                        // accounts,
                        bank,
                        // updated_at: bankFeedLastSyncAt,
                    } = bankFeed || {};
                    return <AccountConnectStatusTag
                        bank={bank}
                        connectedTo={record?.ext_number}
                        connectStatus={bankFeedStatus}
                        lastSyncUntil={record?.sync_ends_at}
                    />;
                }

                return '-';
            },
        },
        {
            title: t`Statement Balance`,
            dataIndex: 'statementBalance',
            key: 'statementBalance',
            align: 'right',
            width: 160,
            render: (text, record) => {
                if (!record.reconciled_date)
                    return '-';
                return (
                    <div>
                        <div>
                            <AmountTd
                                currency_code={record.currency_code}
                                amount={record.reconciled_balance}
                            />
                        </div>
                        <div style={{
                            fontSize: '85%',
                            lineHeight: 1,
                            color: 'rgba(0, 0, 0, 0.50)',
                        }}
                        >
                            {dayjs(record.reconciled_date).format('DD/MM/YYYY')}
                        </div>
                    </div>
                );
            },
        },
        {
            title: t`Current Balance`,
            dataIndex: 'balance',
            key: 'currentBalance',
            align: 'right',
            width: 160,
            render: (text, record) => <AmountTd
                currency_code={record.currency_code}
                amount={record.balance}
            />,
        },
        {
            title: t`Action`,
            key: 'action',
            width: 150,
            align: 'left',
            render: (text, record) => <BankAccountListMenu record={record} />,
        },
    ];
}

export default {
    storageKey: StorageKey.bank_accounts,
    sortable: [
        'name',
        'balance',
    ],
    required: [
        'code',
        'name',
        'system_type',
        'bankFeedStatus',
        'statementBalance',
        'currentBalance',
        'action',
    ],
    defaulto: [
    ],
    hideTitle: [
    ],
    getColumns,
};
